export default __webpack_public_path__ + "static/media/Feretrum of Mitra.74b6f25f.jpg";